import { Component, OnInit, OnDestroy, inject } from '@angular/core';
import { Store } from '@ngrx/store';
// import { TranslateService } from '@ngx-translate/core';
import { TranslateService } from '@ngx-translate/core';
import { profilePlanSelector } from '@app/profile/profile-remaining-count/profile-plan.reducer';
import { ActionProfilePlanGet } from '@app/profile/profile-remaining-count/profile-plan.actions';
import { IProfilePlan } from '@app/profile/main/details';
import { takeUntil } from 'rxjs/operators';
import { Subject } from 'rxjs';
import { ITranslation } from '@app/shared/interfaces/common-interfaces';
import { environment } from '@env/environment';
import { BissService } from '@app/shared/services/biss.service';

@Component({
  selector: 'cloud-profile-remaining-count',
  templateUrl: './profile-remaining-count.component.html',
  styleUrls: ['./profile-remaining-count.component.scss']
})
export class ProfileRemainingCountComponent implements OnInit, OnDestroy {

  lang: string;
  isInfinite: boolean;
  packageRemainingCount: number;
  packageExperationDate: Date;
  packageName: ITranslation;
  readonly dateTimeFormat = environment.dateFormat;

  unsubscribe$: Subject<void> = new Subject<void>();

  private store = inject(Store<any>);
  loginQESCurrent: boolean;
  constructor(
    private translateService: TranslateService,
    public bissService: BissService,
  ) {
    this.lang = this.translateService.currentLang;
  }

  ngOnInit() {
    this.store
      .select(profilePlanSelector)
      .pipe(takeUntil(this.unsubscribe$))
      .subscribe((profilePlan: IProfilePlan) => {
        if (profilePlan) {
          this.isInfinite = profilePlan.remainingCount === -1;
          this.packageRemainingCount = profilePlan.remainingCount;
          if (this.packageRemainingCount > 0 || this.packageRemainingCount !== null) {
            this.loginQESCurrent = true
          } else {
            this.loginQESCurrent = false
          }
          this.packageExperationDate = profilePlan.packageEndDate;
          if (profilePlan.packageData) {
            this.packageName = profilePlan.packageData.name;
          }
        } else {
          this.store.dispatch(new ActionProfilePlanGet());
        }
      });
  }

  ngOnDestroy() {
    this.unsubscribe$.next();
    this.unsubscribe$.complete();
  }

  get planName() {
    return this.packageName[this.translateService.currentLang];
  }

  getYearUnit() {
    return this.translateService.currentLang == 'bg' ? 'г.' : '';
  }
}
